// extracted by mini-css-extract-plugin
export default {"root":"AboutMe_root__dLnap","profile":"AboutMe_profile__1HIiX","role":"AboutMe_role__pDwpE","text":"AboutMe_text__bXC+J","socials":"AboutMe_socials__AA7Ui"};